import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { routes } from '../../../constants';
import { OProjects } from '../';

export default function OIndustrialProjects({ items, className }) {
	return (
		<article className={`section-xx layout-body--xl a-section--slide-off ${className}`}>
			<h2>
				<FormattedMessage id="INDUSTRIAL.OUR_PROJECTS" defaultMessage="" />
			</h2>
			<OProjects
				className="layout-body--md"
				items={items}
			/>
			<footer className="o-footer-load-more">
				<Link
					to={`${routes.INDUSTRIAL.HOME}${routes.PROJECTS}`}
					href={`${routes.INDUSTRIAL.HOME}${routes.PROJECTS}`}
					className="a-button--ghost"
				>
					<FormattedMessage id="INDUSTRIAL.SEE_AL_OUR_PROJECTS" defaultMessage="" />
				</Link>
			</footer>
		</article>
	);
}

OIndustrialProjects.propTypes = {
	items: PropTypes.array,
	className: PropTypes.string,
};
OIndustrialProjects.defaultProps = {
	items: [],
	className: '',
};



// WEBPACK FOOTER //
// ./src/components/organisme/industrial/_organisme.industrial-projects.js